import AbstractView from 'abstract';
import Vue from 'vue'
import Search from 'containers/SearchResults/SearchResults'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        new Vue({
            store,
            ...Search
        }).$mount("#" + this.elemId)
    }
}